module.exports = __webpack_public_path__ + "img/dl_1109_1.c142f68a.jpg";